import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScoreService {
  // Store scores per row { ittId: { tech: score, comm: score } }
  private scores = signal<Record<number, { tech: number, comm: number }>>({});

  // Computed function to get all scores
  get allScores() {
    return this.scores();
  }

  // Initialize scores from backend
  setInitialScores(initialScores: Record<number, { tech: number, comm: number }>) {
    this.scores.set(initialScores);
    console.log('initialScores::this.scores', initialScores);
  }

  // Update either the Technical or Commercial score
  updateScore(applicantOrgId: number, newScore: number, type: 'tech' | 'comm') {
    console.log('applicantOrgId, newScore, type', applicantOrgId, newScore, type);
    const currentScores = this.scores();
    this.scores.set({
      ...currentScores,
      [applicantOrgId]: {
        tech: type === 'tech' ? newScore : currentScores[applicantOrgId]?.tech ?? 0,
        comm: type === 'comm' ? newScore : currentScores[applicantOrgId]?.comm ?? 0,
      }
    });
    console.log('this.scores', this.scores);
  }

  // Get scores for a specific row
  getScores(applicantOrgId: number) {
    return this.scores()[applicantOrgId] ?? { tech: 0, comm: 0 };
  }
}
